import QueryBase from './QueryBase';
/**
 * 降级策略普通搜索
 *
 * @export
 * @class CompatQueryNormal
 * @extends {QueryBase}
 */
export default class CompatQueryNormal extends QueryBase {
  constructor() {
    super();
  }

  async query(start, end) {
    let data = this.dbController.dbData;
    let result = [];
    Array.prototype.slice.call(data).filter((item, index) => {
      if (item.time >= start && item.time <= end) {
        result.push(item);
      }
    });

    return result;
  }
}
